import React from 'react';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import FormControl from 'react-bootstrap/FormControl';
import Util from '../../util/Util';
import SmsConfigurationAPI from '../../api/SmsConfigurationAPI';
import Const from '../../util/Constants';
import withRouter from '../../util/WithRouter';

class SmsConfigurationUpdate extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      inApiCall: true, id: '', name: '', method: 'GET', link: '', hKey: '', hVal: '', headers: {},
      qKey: '', qVal: '', queries: {}, body: '', is_default: 0
    };

    this.id = parseInt(props.match.params.smsConfigId);
    this.base = this.props.match.path;
    this.base = this.base.substring(0, this.base.indexOf('/add-edit'));
  }

  componentDidMount() {
    if (this.id !== 0) {
      this.setState({ ...this.state, id: this.id });
      SmsConfigurationAPI.get(this.id, this.onSuccess, this.onFail);
    } else {
      this.setState({ ...this.state, id: 0 });
    }
  }
  onFail = (res) => {
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false });
  };
  onSuccess = res => {
    res.headers = JSON.parse(res.headers);
    res.queries = JSON.parse(res.query_params);
    this.setState({ ...res });
  };

  onChange = (field, val) => {
    const state = { ...this.state };
    state[field] = val;
    this.setState({ ...state });
  };

  delete = (field, key) => {
    let state = { ...this.state };
    delete state[field][key];
    this.setState({ ...state });
  };
  add = field => {
    let state = { ...this.state };
    const key = field === 'headers' ? this.state.hKey : this.state.qKey;
    state[field][key] = field === 'headers' ? this.state.hVal : this.state.qVal;
    if (field === 'headers') { state.hKey = ''; state.hVal = ''; }
    else { state.qKey = ''; state.qVal = ''; }
    this.setState({ ...state });
  };

  onSave = () => {
    let state = { ...this.state };
    delete state.hKey;
    delete state.hVal;
    delete state.qKey;
    delete state.qVal;
    SmsConfigurationAPI.save(state, this.onUpdateReceived, this.onFail);
  };

  onUpdateReceived = res => this.props.navigate(`${this.base}`);

  render() {
    let get = this.state.method === 'GET';
    let post = this.state.method === 'POST';
    let put = this.state.method === 'PUT';
    let del = this.state.method === 'DELETE';

    let keys = Object.keys(this.state.headers);
    const headers = keys.map((key, _i) =>
      <table>
        <tr key={_i}>
          <td>
            {key} : {this.state.headers[key]}
            <Button className="delete buttons dlt" onClick={() => this.delete('headers', key)}>Delete</Button>
          </td>
        </tr>
      </table>);

    keys = Object.keys(this.state.queries);
    const queries = keys.map(key =>
      <table>
        <tr>
          <td>{key} : {this.state.queries[key]}
            <Button className="delete buttons dlt" onClick={() => this.delete('queries', key)}>Delete</Button>
          </td>
        </tr>
      </table>);

    return (
      <div className="sectionform pt-4">
        <div className="container form-cont">
          <div className="row">
            <div className="col-md-12">
              <h3 className="pb-3">SMS Configuration</h3>
            </div>
          </div>

          <Form className="row row-cols-3 lead-form">
            <div className="col">
              <div className="form-group">
                <label>Name</label>
                <FormControl type="text" value={this.state.name} className="mr-sm-2"
                  onChange={event => this.onChange('name', event.target.value)} />
              </div>
            </div>

            <div className="col">
              <div className="form-group">
                <label>Link</label>
                <FormControl type="text" placeholder="Link"
                  value={this.state.link} className={`mr-sm-2`}
                  onChange={event => this.onChange('link', event.target.value)} />
              </div>
            </div>

            <div className="col">
              <div className="form-group">
                <label>Body</label>
                <FormControl as="textarea" placeholder="Body"
                  value={this.state.body} className={`mr-sm-2`}
                  onChange={event => this.onChange('body', event.target.value)} />
              </div>
            </div>

            <div className="col">
              <div className="form-group">
                <h6>Headers</h6>
                <div className="transactional-sms">
                  <label>Key</label>
                  <FormControl type="text" placeholder="Link"
                    value={this.state.hKey} className={`mr-sm-2`}
                    onChange={event => this.onChange('hKey', event.target.value)} />

                  <label>Value</label>
                  <FormControl type="text" placeholder="Value"
                    value={this.state.hVal} className={`mr-sm-2`}
                    onChange={event => this.onChange('hVal', event.target.value)} />
                  <Button variant="success" onClick={() => this.add('headers')}>Add</Button>
                </div>
              </div>
              {headers}
            </div>

            <div className="col">
              <div className="form-group">
                <h6>Query Parameters</h6>
                <div className="transactional-sms">
                  <label>Key</label>
                  <FormControl type="text" placeholder="Link"
                    value={this.state.qKey} className={`mr-sm-2`}
                    onChange={event => this.onChange('qKey', event.target.value)} />

                  <label>Value</label>
                  <FormControl type="text" placeholder="Value"
                    value={this.state.qVal} className={`mr-sm-2`}
                    onChange={event => this.onChange('qVal', event.target.value)} />

                  <Button variant="success" onClick={() => this.add('queries')}>Add</Button>
                </div>
              </div>
              {queries}
            </div>

            <div className="col">
              <div className="form-group">
                <label>Method</label>
                <Form.Check type="radio">
                  <Form.Check.Input type="radio" checked={get}
                    onChange={() => this.onChange('method', 'GET')} />
                  <Form.Check.Label>GET</Form.Check.Label>
                </Form.Check>
                <Form.Check type="radio">
                  <Form.Check.Input type="radio" checked={post}
                    onChange={() => this.onChange('method', 'POST')} />
                  <Form.Check.Label>POST</Form.Check.Label>
                </Form.Check>
                <Form.Check type="radio">
                  <Form.Check.Input type="radio" checked={put}
                    onChange={() => this.onChange('method', 'PUT')} />
                  <Form.Check.Label>PUT</Form.Check.Label>
                </Form.Check>
                <Form.Check type="radio">
                  <Form.Check.Input type="radio" checked={del}
                    onChange={() => this.onChange('method', 'DELETE')} />
                  <Form.Check.Label>DELETE</Form.Check.Label>
                </Form.Check>
              </div>
            </div>

            <div className="col">
              <div className="form-group">
                <Form.Check type="checkbox">
                  <Form.Check.Input type="checkbox" checked={this.state.is_default === Const.True}
                    onChange={evt => this.onChange('is_default',
                      evt.target.checked ? Const.True : Const.False)} />
                  <Form.Check.Label>Default</Form.Check.Label>
                </Form.Check>
              </div>
            </div>

            <div className="col-md-12 text-center btnsend pt-4">
              <Button variant="success" onClick={this.onSave}>Save</Button>
            </div>
          </Form>
          {/* </ApiUiController> */}
        </div>
      </div>
    );
  }
}
export default withRouter(SmsConfigurationUpdate);